import { render, staticRenderFns } from "./RMOrdersList.vue?vue&type=template&id=a2fd05da&scoped=true&"
import script from "./RMOrdersList.vue?vue&type=script&lang=js&"
export * from "./RMOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./RMOrdersList.vue?vue&type=style&index=0&id=a2fd05da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fd05da",
  null
  
)

export default component.exports